import { useMemo } from 'react'
import { FieldError, UseFormSetValue } from 'react-hook-form'
import { DateTimePickerField } from 'utoniq-ui'

import { FirstComeFirstServedEditValues } from '@/components/pages/ConsolePreSaleEdit/template/FirstComeFirstServedEditForm'
import { LotteryEditValues } from '@/components/pages/ConsolePreSaleEdit/template/LotteryEditForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { convertDatePickerValueToDate, dayjs } from '@/lib/dayjs'

import { FirstComeFirstServedCreateValues } from '../FirstComeFirstServedCreateForm'
import { LotteryCreateValues } from '../LotteryCreateForm'

type DatePickerCellProps = {
  setValue:
    | UseFormSetValue<LotteryCreateValues>
    | UseFormSetValue<LotteryEditValues>
    | UseFormSetValue<FirstComeFirstServedCreateValues>
    | UseFormSetValue<FirstComeFirstServedEditValues>
  value: string | null
  name: string
  error?: FieldError
  desc?: string
}
export const DatePickerCell: Cell<DatePickerCellProps> = ({
  setValue,
  ...props
}) => {
  const { t } = useTranslation('consolePreSaleCreate')
  const value = useMemo(
    () => (props.value ? dayjs(props.value) : null),
    [props.value]
  )
  return (
    <CellFrame sx={{ pb: 5 }}>
      <DateTimePickerField
        onChange={date => {
          // @ts-ignore
          setValue(props.name, convertDatePickerValueToDate(date) as never, {
            shouldValidate: true,
            shouldDirty: true,
          })
        }}
        {...props}
        value={value}
        title={t(`${props.name}Title`)}
        placeholder={t(`${props.name}Placeholder`)}
        description={props.desc}
        textFieldProps={{
          label: props.error ? t('error') : '',
        }}
        titleProps={{
          variant: props.name === 'resultNoticedAt' ? 'h5' : 'subtitle1',
          color: 'text.primary',
        }}
      />
    </CellFrame>
  )
}
